import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';
import utils from 'mewe/utils/environment-utils';

export default buildHelper(function (value) {
  const link = value.join('');

  return htmlSafe(utils.getCdnHost() + link);
});
